export const dispatchScreenBuckets = [
  {
    id : 'in_store_orders',
    name: 'In Store',
  },
  {
    id : 'ongoing_orders',
    name: 'Ongoing',
  },
  {
    id : 'completed_orders',
    name: 'Completed',
  },
  {
    id: 'unassigned_orders',
    name: 'Unassigned',
  },
  {
    id: 'undelivered_orders',
    name: 'Undelivered',
  },
  {
    id: 'cancelled_orders',
    name: 'Cancelled',
  },
];

export const dispatchScreenBucketsPickily = [
  {
    id: 'in_store',
    name: 'In Store',
  },
  {
    id: 'unassigned',
    name: 'Unassigned',
  },
  {
    id: 'ongoing',
    name: 'Ongoing',
  },
  {
    id: 'completed',
    name: 'Completed',
  },
  {
    id: 'rto',
    name: 'RTO',
  },
  {
    id: 'undelivered',
    name: 'Failed',
  },
  {
    id: 'cancelled',
    name: 'Cancelled',
  },
];

export const dispatchScreenPaginationSizes = [20, 50, 100, 200];
